import React, { useState } from "react";
import SpecialOffers from "../../components/home/SpecialOffers/SpecialOffers";
import Breadcrumbs from "../../components/pageProps/Breadcrumbs";
import usePageMeta from "../../utils/usePageMeta";

const Offer = () => {
  usePageMeta({
    title: "Special Offers | MD Wedding Props",
    description:
      "Explore special offers and featured wedding props available now.",
    keywords: "wedding props offers, decor deals, featured wedding props",
  });

  const [prevLocation] = useState("");

  return (
    <div className="max-w-container mx-auto">
      <Breadcrumbs title="Offer" prevLocation={prevLocation} />
      <div className="pb-10">
        <SpecialOffers />
      </div>
    </div>
  );
};

export default Offer;
